import React from "react";

const ObjectDetection = () => {
  return (
    <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center">
      <h1 className="text-5xl font-bold mb-8">Object Detection</h1>
      <p className="text-gray-400 max-w-2xl text-center">
        Identify objects seamlessly in images and videos. Upload your data and let AI detect objects for you.
      </p>
      <button className="mt-8 px-6 py-3 bg-gradient-to-r from-pink-400 to-purple-400 text-white font-bold rounded-lg shadow-lg">
        Upload Image/Video
      </button>
    </div>
  );
};

export default ObjectDetection;